import Base from '../common/Base';
import './index.scss';

// 自右划入动画组件
function SlideLeft(props) {
  return (<Base classNames="slide-left" {...props}></Base>);
}

export default SlideLeft;